import { useState } from "react";
import { auctions } from "../../collectionsData";


const Auction = () => {
    
    const [auction] = useState(auctions[0]);

    return(
        <div className="bg-[white] dark:bg-dark-content-bg dark:text-white px-[5vw] md:px-10  transition-colors duration-300 ease-in-out">
            <div className="max-w-[1400px] mx-auto">

            <div className="flex flex-col items-center justify-center">
                <div className="max-w-[600px] mb-20">
                    <img src = {auction.image} alt = 'auction' className="w-[100%]"/>
                </div>

                <div className="flex flex-col lg:flex-row lg:justify-between">
                    
                    <div className="flex flex-col lg:w-[45%] max-w-[700px]">
                        <h1 className="font-bold text-lg md:text-2xl lg:text-4xl xl:text-6xl mb-5">
                            {auction.title}
                        </h1>
                        <p className="text-sm md:text-base lg:text-lg mb-3">
                            <span className = 'text-gray-500'>CREATED BY: </span> {auction.createdBy}
                        </p>

                        <div className="flex">
                            <a href = '/' target='_blank' className="mr-3 w-[25px] h-[25px]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 496 512">
                                    <path d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"/>
                                </svg>
                            </a>
                            <a href = '/' target='_blank' className="mr-3 w-[30px] h-[25px]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 640 512">
                                    <path d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"/>
                                </svg>
                            </a>
                            <a href = '/' target='_blank' className="mr-3 w-[25px] h-[25px]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 496 512">
                                    <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"/>
                                </svg>
                            </a>
                            <a href = '/' target='_blank' className="w-[25px] h-[25px]">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 496 512">
                                    <path d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"/>
                                </svg>
                            </a>
                        </div>

                        <p className="text-sm md:text-base lg:text-lg text-gray-500 mb-3">
                            {auction.description}
                        </p>

                        <p className="text-sm md:text-base lg:text-lg mb-3">
                            Attributes
                        </p>

                        <div className="flex flex-wrap">
                            <div className="flex flex-col justify-center p-3 max-w-100px  m-2 shadow-shadow3 dark:bg-gray-700 rounded-[7px]">
                                <p className="text-sm lg:text-base text-main">
                                    GENERATION
                                </p>
                                <p className="text-sm lg:text-base">
                                    2
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px  m-2 shadow-shadow3 dark:bg-gray-700 rounded-[7px]">
                                <p className="text-sm lg:text-base text-main">
                                    LINEAGE
                                </p>
                                <p className="text-sm lg:text-base">
                                    Stunt
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px m-2 shadow-shadow3 dark:bg-gray-700 rounded-[7px]">
                                <p className="text-sm lg:text-base text-main">
                                    PROGENITOR
                                </p>
                                <p className="text-sm lg:text-base">
                                    True
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px shadow-shadow3 m-2 dark:bg-gray-700 rounded-[7px]">
                                <p className="text-sm lg:text-base text-main">
                                    CREATOR
                                </p>
                                <p className="text-sm lg:text-base">
                                    {auction.createdBy}
                                </p>
                            </div>
                            <div className="flex flex-col justify-center p-3 max-w-100px shadow-shadow3 m-2 dark:bg-gray-700 rounded-[7px]">
                                <p className="text-sm lg:text-base text-main">
                                    CANVAS
                                </p>
                                <p className="text-sm lg:text-base">
                                    80x80
                                </p>
                            </div>
                        </div>


                    </div>

                    <div className="flex flex-col lg:w-[47%] max-w-[700px] mt-10 lg:mt-0">
                        <div className="flex flex-col sm:flex-row justify-between w-full p-3 shadow-shadow3 lg:m-2 mb-4 dark:bg-gray-700 rounded-[7px]">
                            <div className="flex flex-col mb-3 sm:mb-0">
                                <p className="text-sm lg:text-base ">
                                    CURRENT BID
                                </p>
                                <p className="text-base lg:text-lg">
                                    34.56
                                </p>
                                <p className="text-sm lg:text-base text-gray-400">
                                    MINIMUM BID: 33.26
                                </p>
                            </div>
                            <div className="flex flex-col">
                                <p className="text-sm lg:text-base ">
                                    AUCTION ENDS IN
                                </p>
                                <div className="flex">
                                    <div className="flex flex-col items-center justify-center m-2">
                                        <p className="text-base lg:text-lg">
                                            34
                                        </p>
                                        <p className="text-sm text-gray-400">
                                            HOURS
                                        </p>
                                    </div>
                                    <div className="flex flex-col items-center justify-center m-2">
                                        <p className="text-base lg:text-lg">
                                            34
                                        </p>
                                        <p className="text-sm text-gray-400">
                                            MINUTES
                                        </p>
                                    </div>
                                    <div className="flex flex-col items-center justify-center m-2">
                                        <p className="text-base lg:text-lg">
                                            7
                                        </p>
                                        <p className="text-sm  text-gray-400">
                                            SECONDS
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex w-full p-3 shadow-shadow3 lg:mx-2 my-4 dark:bg-gray-700 rounded-[7px]">
                            <p className="text-sm  text-gray-400">
                                Last Bid By: <span className="text-main">somename</span>, 16th June 2020 at 12:34:00 GMT +5
                            </p>
                        </div>

                        <div className="text-sm lg:text-base text-gray-500 lg:mx-2 mt-10">
                            <p>
                                How it works:
                            </p>
                            <ul>
                                <li>1. Connect your wallet and place a bid. The bid must be at least 0.25 SOL greater than the current bid</li>
                                <li>2. You will automatically get your SOL returned to your wallet if outbid</li>
                                <li>3. If a bid is received 5 minutes from the end of the auction, the bidding time will be extended by 5 minutes</li>
                                <li>4. When auction closes, the artwork will belong to the highest bidder. Please claim the NFT by pressing the “claim item” button</li>
                            </ul>
                        </div>
                    </div>

                </div>



            </div>

            </div>
        </div>
    )
}

export default Auction;